export interface Preferences {
  user_id: number;
  id: number;
  assets: string;
  created_at?: any;
  updated_at: string;
}

export interface User {
  id: number;
  name: string;
  email: string;
  investor_type: number;
  profile_picture: string;
  is_premium: number;
  created_at: Date;
  updated_at: Date;
  email_verified_at?: any;
  preferences: Preferences;
}

export enum eInvestorType {
  DAY_TRADER,
  SWING_TRADER,
  BUY_AND_HOLDER,
}

export interface UserFollowingAsset {
  status: boolean;
  name: string;
  symbol: string;
  type: number;
  country_code: number;
  exchange?: string;
  currency_symbol: string;
  encoded_id: string;
  icon?: string;
}

export enum eNotificationRead {
  NOT_READ,
  READ,
}

export interface UserNotification {
  id: number;
  title: string;
  description: string;
  action_url?: string;
  is_read: eNotificationRead;
  user_id: number;
  created_at: string;
  updated_at: string;
  deleted_at?: any;
}

export interface OpenedNotificationParam {
  isOpen: boolean;
  notification: UserNotification;
}

export interface CreateUserAccountDto {
  name: string;
  email: string;
  password: string;
  phone: string;
  confirmation_code: string;
}

export interface CreateUserAccountResponse {
  status: number;
  msg: string;
  data?: {
    token: string;
    name: string;
  };
}

export interface UserDetailsResponse {
  status: number;
  msg: string;
  data: {
    id: number;
    name: string;
    email: string;
    investor_type: number;
    profile_picture: string;
    is_premium: number;
    created_at: Date;
    updated_at: Date;
    email_verified_at?: any;
    stripe_id: string;
    pm_type: string;
    pm_last_four: string;
    trial_ends_at?: any;
    is_external_auth: boolean;
    preferences: {
      user_id: number;
      id: number;
      assets: string;
      created_at?: any;
      updated_at: string;
    };
  };
}

export interface UserFirstStepsDto {
  investorType: eInvestorType;
  profileImage: string;
  assets: string;
}

export interface UserFirstStepsResponse {
  status: number;
}

export interface UpdateUserRequest {
  userName: string;
  profilePicture: null;
  investorType: number;
  newPassword: string | null;
  confirmNewPassword: string | null;
  oldPassword: string | null;
}

export interface UpdateUserResponse {
  status: number;
  msg: string;
  data: any;
}

export interface UploadProfileImageResponse {
  msg: string;
  fileName?: string;
}
